import { Field, Form, Formik } from "formik";
import Button from "pages/_components/Button";
import TextField from "pages/_components/fields/TextField";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import React from "react";
import { Col, Row } from "react-bootstrap";
import * as i18n from "util/i18n";
import BillInfoSummary from "../components/BillsInfoSummary";
import ActionBillTable from "../components/Table";
import { useAction } from "../hooks/useAction";

const ActionFCEMPage = ({ isDesktop }) => {
    const { form, tabOption, bills, actionI18n } = useAction();
    const { initialValues, handleSubmit, validationSchema } = form;

    const hasMoreThan1Bill = bills?.length > 1;

    return (
        <>
            <Notification scopeToShow="actionFCEMPage" />
            <ResponsiveHeader id={`creditBill.${actionI18n}`} showLabel />
            <MainContainer className="credit-bills">
                <ActionBillTable isDesktop={isDesktop} tabOption={tabOption} bills={bills} />
                {hasMoreThan1Bill && <BillInfoSummary bills={bills} isDesktop={isDesktop} />}
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validationSchema={validationSchema}>
                    <Form>
                        <Row>
                            <Col xs={12} md={6}>
                                <Field
                                    component={TextField}
                                    labelnoI18n={i18n.get(`creditBill.${actionI18n}.motive.label`)}
                                    placeholderText={i18n.get("creditBill.motive.placeholder")}
                                    name="motive"
                                    type="text"
                                    maxLength="150"
                                />
                            </Col>
                        </Row>

                        <Row className="form-actions">
                            <Col xs={12} md={4} mdOffset={isDesktop ? 4 : 0}>
                                <Button type="submit" className="btn-primary" label="global.continue" />
                            </Col>
                        </Row>
                    </Form>
                </Formik>
            </MainContainer>
        </>
    );
};

ActionFCEMPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default ActionFCEMPage;
